export const globals: any = {
  groupings: ['Agriculture & Conservation','Business','Construction','Creative','Education & Government','Engineering & Manufacturing','Health, Beauty & Wellbeing','Home Services','Hospitality, Tourism & Retail','Information Technology','Transport & Mining'],
  classifications: {
    'Agriculture & Conservation': ['Agriculture','Arborist (Commercial)','Conservation','Farming','Fishing','Forestry & Logging','Seasonal & Picking','Wildlife & Zoo','Other'],
    'Business': ['Accounting & Tax','Banking & Finance','Cleaning (Commercial)','Customer Service','Human Resources','Immigration','Insurance','Legal','Management & Leadership','Office Administration','Project & Product Management','Risk & Compliance','Sales & Marketing','Security (Physical Commercial)','Remote & Virtual Assistants','Other'],
    'Construction': ['Architecture & Design (Building)','Building (Commercial)','Carpentry (Commercial)','Electrical (Commercial)','General Labour','Glazing','Heating & Cooling','Heavy Machinery Operation','Painting & Decorating (Commercial)','Plumbing (Commercial)','Project Management (Construction)','Roofing','Scaffolding','Surveying','Traffic Management','Welding','Other'],
    'Creative': ['Acting & Modelling','Advertising','Arts & Craft','Animation & Ilustration','Blogging & Writing','Communications & Media','Copywriting & Content Creation','Dance & Performing Arts','Design','Film & Video','Music','Photography','Social Media Management','Stage & Theatre','Voice & Sound','Other'],
    'Education & Government': ['Childcare (Pre-School)','Coastguard & LifeGuard','Education & Teaching','Fire & Rescue','Government Agencies','Language & Translation','Military','Police','Science & Research','Transcription & Proofreading','Other'],
    'Engineering & Manufacturing': ['Assembly & Processing','Chemical Engineering','Civil Engineering','Electrical & Electronics Engineering','Environmental Engineering','Industrial & Warehouse','Loading, Stocking & Packing','Mechanical Engineering','Robotics & Automation (Industrial)','Structural Engineering','Waste Management','Other'],
    'Health, Beauty & Wellbeing': ['Ambulance & Paramedics','Community & Charity','Counselling & Social Services','Dental','Diet & Nutrition','Disability Support','Doctors, Physicians & Surgeons','Fashion, Beauty & Nails','Hair & Makeup','Health & Hospital','Life Coach','Medical & Pharmacy','Nursing','Opticians & Optometrists','Therapists','Sports & Leisure','Veterinary','Other'],
    'Home Services': ['Babysitting','Building & Renovation (Residential)','Cleaning (Residential)','Dog Walking','Electrician (Residential)','Entertainment','Flat Pack Installation','Gardening, Lawns & Mowing','Handyman & Property Maintenance','Interior Design','Painting & Decorating (Residential)','Personal Tuition','Pest Control','Pet Services','Plumber (Residential)','Real Estate & Property Management','Roofing (Residential)','Security (Residential)','Tree Services (Residential)','Other'],
    'Hospitality, Tourism & Retail': ['Accommodation','Events & Festivals','Hospitality','Retail','Tourism','Other'],
    'Information Technology': ['Architecture, Design & Consulting (IT)','Artificial Intelligence & Machine Learning','Automation & Devops','Blockchain & Crypto','Cloud Computing','Database Administration & Analysis','Graphic & UI/UX Design','Hardware Engineering','Information & Cyber Security','Management & Leadership (IT)','Mobile & App Development','Network Engineering','Operations & Support (IT)','Project Management & Delivery (IT)','Service Management (IT)','Software Development','Systems & Infrastructure','Testing & QA','Telecommunications','Web Design & Development','Other'],
    'Transport & Mining': ['Aviation & Air','Automotive: Bike, Car & Truck','Boating & Marine','Bus & Rail','Driving & Delivery','Logistics, Freight & Shipping','Mining','Oil & Gas','Other']
  },
  // standard pricing 0% client fees, 15% service provider fees
  costs: {
    fees: 0.00,
    stfees: 0.029,
    stfixed: 0.3,
    customer: 1.00,
    gigexchange: 0.15,
    gegst: 0.0225,
    getotal: 0.1725,
    provider: 0.8275,
    nogst: 0.85,
    spgst: 0.8275 * 3 / 23,
    spnet: 0.8275 * 20 / 23,
    staccount: 2,
    stpayout: 0.0025,
    stpayfixed: 0.25,
    job: 20 * 1.15,
    jobgst: 20 * 0.15,
    jobgetotal: 20,
    ad: 20 * 1.15,
    adgst: 20 * 0.15,
    adgetotal: 20,
  },
  // early bird pricing 0% client fees, 5% service provider fees
  promo: {
    fees: 0.00,
    stfees: 0.029,
    stfixed: 0.3,
    customer: 1.00,
    gigexchange: 0.05,
    gegst: 0.0075,
    getotal: 0.0575,
    provider: 0.9425,
    nogst: 0.95,
    spgst: 0.9425 * 3 / 23,
    spnet: 0.9425 * 20 / 23,
    staccount: 2,
    stpayout: 0.0025,
    stpayfixed: 0.25,
    job: 5 * 1.15,
    jobgst: 5 * 0.15,
    jobgetotal: 5,
    ad: 5 * 1.15,
    adgst: 5 * 0.15,
    adgetotal: 5,
  },
  tax: {
    gst: 0.15,
  },
  countries: [
    {
      name: 'Global',
      named: 'Global',
      welcome: 'Hello & welcome',
      slug: 'global',
      subdomain: '',
      code: '',
      currency: 'GXD',
      hreflang: 'en',
      active: true
    },
    {
      name: 'Australia',
      named: 'Australian',
      welcome: 'G’day & welcome',
      slug: 'australia',
      subdomain: 'au',
      code: 'AU',
      currency: 'AUD',
      hreflang: 'en-au',
      active: true
    },
    {
      name: 'Austria',
      named: 'Austrian',
      welcome: 'Hallo und Willkommen',
      slug: 'austria',
      subdomain: 'at',
      code: 'AT',
      currency: 'EUR',
      hreflang: 'en-at',
      active: true
    },
    {
      name: 'Belgium',
      named: 'Belgian',
      welcome: 'Hallo en welkom',
      slug: 'belgium',
      subdomain: 'be',
      code: 'BE',
      currency: 'EUR',
      hreflang: 'en-be',
      active: true
    },
    {
      name: 'Bulgaria',
      named: 'Bulgarian',
      welcome: 'Zdraveĭ i dobre doshŭl',
      slug: 'bulgaria',
      subdomain: 'bg',
      code: 'BG',
      currency: 'BGN',
      hreflang: 'en-bg',
      active: true
    },
    {
      name: 'Canada',
      named: 'Canadian',
      welcome: 'Hello eh! Welcome eh!',
      slug: 'canada',
      subdomain: 'ca',
      code: 'CA',
      currency: 'CAD',
      hreflang: 'en-ca',
      active: true
    },
    {
      name: 'Cyprus',
      named: 'Cypriot',
      welcome: 'Geiá sas kai kalós írthate',
      slug: 'cyprus',
      subdomain: 'cy',
      code: 'CY',
      currency: 'EUR',
      hreflang: 'en-cy',
      active: true
    },
    {
      name: 'Czech Republic',
      named: 'Czech',
      welcome: 'Ahoj a vítejte',
      slug: 'czech-republic',
      subdomain: 'cz',
      code: 'CZ',
      currency: 'CZK',
      hreflang: 'en-cz',
      active: true
    },
    {
      name: 'Denmark',
      named: 'Danish',
      welcome: 'Hej og velkommen',
      slug: 'denmark',
      subdomain: 'dk',
      code: 'DK',
      currency: 'DKK',
      hreflang: 'en-dk',
      active: true
    },
    {
      name: 'Estonia',
      named: 'Estonian',
      welcome: 'Tere ja Tere tulemast',
      slug: 'estonia',
      subdomain: 'ee',
      code: 'EE',
      currency: 'EUR',
      hreflang: 'en-ee',
      active: true
    },
    {
      name: 'Finland',
      named: 'Finnish',
      welcome: 'Hei ja tervetuloa',
      slug: 'finland',
      subdomain: 'fi',
      code: 'FI',
      currency: 'EUR',
      hreflang: 'en-fi',
      active: true
    },
    {
      name: 'France',
      named: 'French',
      welcome: 'Bonjour et bienvenue',
      slug: 'france',
      subdomain: 'fr',
      code: 'FR',
      currency: 'EUR',
      hreflang: 'en-fr',
      active: true
    },
    {
      name: 'Germany',
      named: 'German',
      welcome: 'Hallo und Willkommen',
      slug: 'germany',
      subdomain: 'de',
      code: 'DE',
      currency: 'EUR',
      hreflang: 'en-de',
      active: true
    },
    {
      name: 'Gibraltar',
      named: 'Gibraltarian',
      welcome: 'Hello and welcome',
      slug: 'gibraltar',
      subdomain: 'gi',
      code: 'GI',
      currency: 'GIP',
      hreflang: 'en-gi',
      active: true
    },
    {
      name: 'Greece',
      named: 'Greek',
      welcome: 'Geiá sas kai kalós írthate',
      slug: 'greece',
      subdomain: 'gr',
      code: 'GR',
      currency: 'EUR',
      hreflang: 'en-gr',
      active: true
    },
    {
      name: 'Hong Kong',
      named: 'Hong Kong',
      welcome: 'Neih hou',
      slug: 'hong-kong',
      subdomain: 'hk',
      code: 'HK',
      currency: 'HKD',
      hreflang: 'en-hk',
      active: true
    },
    {
      name: 'Hungary',
      named: 'Hungarian',
      welcome: 'Helló és üdvözlet',
      slug: 'hungary',
      subdomain: 'hu',
      code: 'HU',
      currency: 'HUF',
      hreflang: 'en-hu',
      active: true
    },
    {
      name: 'Ireland',
      named: 'Irish',
      welcome: 'How’ya, enjoy the craic',
      slug: 'ireland',
      subdomain: 'ie',
      code: 'IE',
      currency: 'EUR',
      hreflang: 'en-ie',
      active: true
    },
    {
      name: 'Italy',
      named: 'Italian',
      welcome: 'Ciao e Benvenuto',
      slug: 'italy',
      subdomain: 'it',
      code: 'IT',
      currency: 'EUR',
      hreflang: 'en-it',
      active: true
    },
    {
      name: 'Japan',
      named: 'Japanese',
      welcome: 'Konnichiwa irasshai',
      slug: 'japan',
      subdomain: 'jp',
      code: 'JP',
      currency: 'JPY',
      hreflang: 'en-jp',
      active: true
    },
    {
      name: 'Latvia',
      named: 'Latvian',
      welcome: 'sveiks un laipni',
      slug: 'latvia',
      subdomain: 'lv',
      code: 'LV',
      currency: 'EUR',
      hreflang: 'en-lv',
      active: true
    },
    {
      name: 'Lithuania',
      named: 'Lithuanian',
      welcome: 'Labas ir sveiki atvykę',
      slug: 'lithuania',
      subdomain: 'lt',
      code: 'LT',
      currency: 'EUR',
      hreflang: 'en-lt',
      active: true
    },
    {
      name: 'Luxembourg',
      named: 'Luxembourg',
      welcome: 'moien an häerzlech',
      slug: 'luxembourg',
      subdomain: 'lu',
      code: 'LU',
      currency: 'EUR',
      hreflang: 'en-lu',
      active: true
    },
    {
      name: 'Malaysia',
      named: 'Malaysian',
      welcome: 'salam dan selamat datang',
      slug: 'malaysia',
      subdomain: 'my',
      code: 'MY',
      currency: 'MYR',
      hreflang: 'en-my',
      active: true
    },
    {
      name: 'Malta',
      named: 'Maltese',
      welcome: 'bonjour u milqugħa',
      slug: 'malta',
      subdomain: 'mt',
      code: 'MT',
      currency: 'EUR',
      hreflang: 'en-mt',
      active: true
    },
    {
      name: 'Netherlands',
      named: 'Dutch',
      welcome: 'Hallo en welkom',
      slug: 'netherlands',
      subdomain: 'nl',
      code: 'NL',
      currency: 'EUR',
      hreflang: 'en-nl',
      active: true
    },
    {
      name: 'New Zealand',
      named: 'NZ',
      welcome: 'Kia Ora & Welcome',
      slug: 'new-zealand',
      subdomain: 'nz',
      code: 'NZ',
      currency: 'NZD',
      hreflang: 'en-nz',
      active: true
    },
    {
      name: 'Norway',
      named: 'Norwegian',
      welcome: 'Hei og velkommen',
      slug: 'norway',
      subdomain: 'no',
      code: 'NO',
      currency: 'NOK',
      hreflang: 'en-no',
      active: true
    },
    {
      name: 'Peru',
      named: 'Peruvian',
      welcome: 'Hola y bienvenido',
      slug: 'peru',
      subdomain: 'pe',
      code: 'PE',
      currency: 'PEN',
      hreflang: 'en-pe',
      active: false
    },
    {
      name: 'Poland',
      named: 'Polish',
      welcome: 'cześć i witaj',
      slug: 'poland',
      subdomain: 'pl',
      code: 'PL',
      currency: 'PLN',
      hreflang: 'en-pl',
      active: true
    },
    {
      name: 'Portugal',
      named: 'Portuguese',
      welcome: 'Olá e bem-vindo',
      slug: 'portugal',
      subdomain: 'pt',
      code: 'PT',
      currency: 'EUR',
      hreflang: 'en-pt',
      active: true
    },
    {
      name: 'Romania',
      named: 'Romanian',
      welcome: 'Bună și bunvenit',
      slug: 'romania',
      subdomain: 'ro',
      code: 'RO',
      currency: 'RON',
      hreflang: 'en-ro',
      active: true
    },
    {
      name: 'Singapore',
      named: 'Singaporean',
      welcome: 'salam dan selamat datang',
      slug: 'singapore',
      subdomain: 'sg',
      code: 'SG',
      currency: 'SGD',
      hreflang: 'en-sg',
      active: true
    },
    {
      name: 'Slovakia',
      named: 'Slovakian',
      welcome: 'Ahoj a Vitaj',
      slug: 'slovakia',
      subdomain: 'sk',
      code: 'SK',
      currency: 'EUR',
      hreflang: 'en-sk',
      active: true
    },
    {
      name: 'Slovenia',
      named: 'Slovenian',
      welcome: 'pozdravljeni in dobrodošli',
      slug: 'slovenia',
      subdomain: 'si',
      code: 'SI',
      currency: 'EUR',
      hreflang: 'en-sl',
      active: true
    },
    {
      name: 'Spain',
      named: 'Spanish',
      welcome: 'Hola y bienvenido',
      slug: 'spain',
      subdomain: 'es',
      code: 'ES',
      currency: 'EUR',
      hreflang: 'en-es',
      active: true
    },
    {
      name: 'Sweden',
      named: 'Swedish',
      welcome: 'Hej och välkommen',
      slug: 'sweden',
      subdomain: 'se',
      code: 'SE',
      currency: 'SEK',
      hreflang: 'en-se',
      active: true
    },
    {
      name: 'Switzerland',
      named: 'Swiss',
      welcome: 'Hallo und Willkommen',
      slug: 'switzerland',
      subdomain: 'ch',
      code: 'CH',
      currency: 'CHF',
      hreflang: 'en-ch',
      active: true
    },
    {
      name: 'United Arab Emirates',
      named: 'UAE',
      welcome: '’ahlaan wamarhabaan',
      slug: 'uae',
      subdomain: 'ae',
      code: 'AE',
      currency: 'AED',
      hreflang: 'en-ae',
      active: true
    },
    {
      name: 'United Kingdom',
      named: 'UK',
      welcome: 'Hiya come in for a cup of tea',
      slug: 'uk',
      subdomain: 'uk',
      code: 'GB',
      currency: 'GBP',
      hreflang: 'en-gb',
      active: true
    },
    {
      name: 'United States of America',
      named: 'USA',
      welcome: 'Hey y’all welcome partner',
      slug: 'us',
      subdomain: 'us',
      code: 'US',
      currency: 'USD',
      hreflang: 'en-us',
      active: true
    }
  ],
  directory: {
    'AU' : {
      name: 'Australia',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '12345678',
      bank_account_digits: '5-9 character',
      bank_account_min: 5,
      bank_account_max: 9,
      bank_account_pattern: '[0-9]{5,9}',
      bank_routing: 'required',
      bank_routing_label: 'BSB',
      bank_routing_format: '123456',
      bank_routing_digits: '6 character',
      bank_routing_min: 6,
      bank_routing_max: 6,
      bank_routing_pattern: '[0-9]{6}',
      calling: '+61',
      calling_digits: '10 digits',
      calling_format: '7 6767 6576',
      calling_min: 12,
      calling_max: 12,
      code: 'AU',
      company_tax: 'required',
      company_tax_label: 'Australian Business Number (ABN)',
      company_tax_format: '123456789',
      company_tax_digits: '9 digit',
      company_tax_min: 8,
      company_tax_max: 9,
      company_tax_link: 'https://www.abnaustralia.com.au/small-business-hub/abn-application',
      company_tax_pattern: '[0-9]{8,9}',
      company_vat: 'optional',
      company_vat_label: 'GST number',
      company_vat_digits: '9 digit',
      company_vat_min: 8,
      company_vat_max: 9,
      company_vat_format: '123456789',
      company_vat_link: 'https://www.ato.gov.au/Business/GST/Registering-for-GST/',
      company_vat_pattern: '[0-9]{8,9}',
      currency: 'aud',
      currency_decimals: 2,
      currency_symbol: 'AU$',
      minimum_wage: 21.38,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'State',
      slug: 'australia',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'AT' : {
      name: 'Austria',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'AT611904300234573201',
      bank_account_digits: '20 characters',
      bank_account_min: 20,
      bank_account_max: 20,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+43',
      calling_digits: '10 digits',
      calling_format: '1 2345 6789',
      calling_min: 12,
      calling_max: 12,
      code: 'AT',
      company_tax: 'required',
      company_tax_label: 'Company register ID (Firmenbuchnummer)',
      company_tax_format: '123456k',
      company_tax_digits: '6 digit, then 1 letter',
      company_tax_min: 6,
      company_tax_max: 7,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{6}[a-z]{1}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (UID)',
      company_vat_digits: 'AT + U + 9 digits',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: 'ATU123455555',
      company_vat_link: '',
      company_vat_pattern: '[A]{1}[T]{1}[U]{1}[0-9]{9}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'austria',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'BE' : {
      name: 'Belgium',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'BE12345678912345',
      bank_account_digits: '16 characters',
      bank_account_min: 16,
      bank_account_max: 16,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+32',
      calling_digits: '10-11 digits',
      calling_format: '123 45 67',
      calling_min: 10,
      calling_max: 11,
      code: 'BE',
      company_tax: 'required',
      company_tax_label: 'TVA/BTW/CBE',
      company_tax_format: 'BE0999999999',
      company_tax_digits: 'BE then 10 digit',
      company_tax_min: 12,
      company_tax_max: 12,
      company_tax_link: '',
      company_tax_pattern: '[B]{1}[E]{1}[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: 'BE then 10 digit',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: 'BE1234567890',
      company_vat_link: '',
      company_vat_pattern: '[B]{1}[E]{1}[0-9]{10}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 9.49,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'belgium',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'BG' : {
      name: 'Bulgaria',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'BG80BNBG96611020345678',
      bank_account_digits: '22 characters',
      bank_account_min: 22,
      bank_account_max: 22,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+359',
      calling_digits: '12 digits',
      calling_format: '12345678',
      calling_min: 12,
      calling_max: 12,
      code: 'BG',
      company_tax: 'required',
      company_tax_label: 'Unique Identification Code (ЕИК/ПИК)',
      company_tax_format: '9999999999',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: 'BG then 10 digit',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: 'BG1234567890',
      company_vat_link: '',
      company_vat_pattern: '[B]{1}[G]{1}[0-9]{10}',
      currency: 'bgn',
      currency_decimals: 2,
      currency_symbol: 'лв',
      minimum_wage: 4.43,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Province',
      slug: 'bulgaria',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'CA' : {
      name: 'Canada',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '000123456789',
      bank_account_digits: '7-12 character',
      bank_account_min: 7,
      bank_account_max: 12,
      bank_account_pattern: '[0-9]{7,12}',
      bank_routing: 'required',
      bank_routing_label: 'Routing number',
      bank_routing_format: '12345 678',
      bank_routing_digits: '5 digit transit number & 3 digit institution number',
      bank_routing_min: 8,
      bank_routing_max: 9,
      bank_routing_pattern: '[0-9]{8,9}',
      calling: '+1',
      calling_digits: '10 digits',
      calling_format: '(250) 555-1234',
      calling_min: 12,
      calling_max: 12,
      code: 'CA',
      company_tax: 'required',
      company_tax_label: 'Business number',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_format: '123456789',
      company_tax_link: 'https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/register.html',
      company_tax_pattern: '[0-9]{9}',
      currency: 'cad',
      currency_decimals: 2,
      currency_symbol: 'CA$',
      minimum_wage: 15.55,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '6 character',
      post_code_format: 'ANA NAN',
      post_code_min: 6,
      post_code_max: 7,
      post_code_pattern: '[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]',
      post_code_prefix: '',
      region_state: 'Province',
      slug: 'canada',
      tax_label: 'GST',
      tax_rate: 0,
      town_city: 'Towns & Cities'
    },
    'CY' : {
      name: 'Cyprus',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'CY17002001280000001200527600',
      bank_account_digits: '28 characters',
      bank_account_min: 28,
      bank_account_max: 28,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+357',
      calling_digits: '12 digits',
      calling_format: '12 345678',
      calling_min: 12,
      calling_max: 12,
      code: 'CY',
      company_tax: 'required',
      company_tax_label: 'Tax Identification Code',
      company_tax_format: '12345678R',
      company_tax_digits: '8 digit and 1 letter',
      company_tax_min: 8,
      company_tax_max: 9,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{8}[A-Z]{1}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'cyprus',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'CZ' : {
      name: 'Czech Republic',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'CZ6508000000192000145399',
      bank_account_digits: '24 characters',
      bank_account_min: 24,
      bank_account_max: 24,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+420',
      calling_digits: '13 digits',
      calling_format: '123 456 789',
      calling_min: 13,
      calling_max: 13,
      code: 'CZ',
      company_tax: 'required',
      company_tax_label: 'IČO (Company Identification Number)',
      company_tax_format: '12345678',
      company_tax_digits: '8 digit',
      company_tax_min: 8,
      company_tax_max: 8,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (DIČ)',
      company_vat_digits: 'CZ then 8 digit',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: 'CZ12345678',
      company_vat_link: '',
      company_vat_pattern: '[C]{1}[Z]{1}[0-9]{8}',
      currency: 'czk',
      currency_decimals: 2,
      currency_symbol: 'Kč',
      minimum_wage: 96.4,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '3 digit, space, then 2 digit',
      post_code_format: 'NNN NN',
      post_code_min: 5,
      post_code_max: 6,
      post_code_pattern: '[0-9][0-9][0-9] [0-9][0-9]',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'czech-republic',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'DK' : {
      name: 'Denmark',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'DK5000400440116243',
      bank_account_digits: '18 characters',
      bank_account_min: 18,
      bank_account_max: 18,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+45',
      calling_digits: '11 digits',
      calling_format: '45 12 45 67',
      calling_min: 11,
      calling_max: 11,
      code: 'DK',
      company_tax: 'required',
      company_tax_label: 'VAT registration (CVR)',
      company_tax_format: 'DK12345678',
      company_tax_digits: 'DK then 8 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_link: '',
      company_tax_pattern: '[D]{1}[K]{1}[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: 'DK then 8 digit',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: 'DK12345678',
      company_vat_link: '',
      company_vat_pattern: '[D]{1}[K]{1}[0-9]{8}',
      currency: 'dkk',
      currency_decimals: 2,
      currency_symbol: 'kr',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'denmark',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'EE' : {
      name: 'Estonia',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'EE382200221020145685',
      bank_account_digits: '20 characters',
      bank_account_min: 20,
      bank_account_max: 20,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+372',
      calling_digits: '11 digits',
      calling_format: '3 45 67 89',
      calling_min: 11,
      calling_max: 11,
      code: 'EE',
      company_tax: 'required',
      company_tax_label: 'Company Number',
      company_tax_format: '12345678',
      company_tax_digits: '8 digit',
      company_tax_min: 8,
      company_tax_max: 8,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (KMKR)',
      company_vat_digits: 'EE then 9 digit',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'EE123456789',
      company_vat_link: '',
      company_vat_pattern: '[E]{1}[E]{1}[0-9]{9}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 3.44,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'County',
      slug: 'estonia',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'FI' : {
      name: 'Finland',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'FI2112345600000785',
      bank_account_digits: '18 characters',
      bank_account_min: 18,
      bank_account_max: 18,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+358',
      code: 'FI',
      calling_digits: '12-13 digits',
      calling_format: '45 123 45 67',
      calling_min: 12,
      calling_max: 13,
      company_tax: 'required',
      company_tax_label: 'Finnish Business ID (Y-tunnus)',
      company_tax_format: '12345678-9',
      company_tax_digits: '9 digits',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT Number',
      company_vat_digits: 'FI then 9 digit Business ID, is your',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'FI123456789',
      company_vat_link: '',
      company_vat_pattern: '[F]{1}[I]{1}[0-9]{9}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'finland',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'FR' : {
      name: 'France',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'FR1420041010050500013M02606',
      bank_account_digits: '27 characters',
      bank_account_min: 27,
      bank_account_max: 27,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+33',
      calling_digits: '12 digits',
      calling_format: '1 40 00 00 00',
      calling_min: 12,
      calling_max: 12,
      code: 'FR',
      company_tax: 'required',
      company_tax_label: 'Business Registration Number - (SIRET)',
      company_tax_format: '123456789 12345',
      company_tax_digits: '14 digits',
      company_tax_min: 14,
      company_tax_max: 14,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{14}',
      company_vat: 'optional',
      company_vat_label: 'VAT Number',
      company_vat_digits: 'FR then 11 digits',
      company_vat_min: 13,
      company_vat_max: 13,
      company_vat_format: 'FR12345678901',
      company_vat_link: '',
      company_vat_pattern: '[F]{1}[R]{1}[0-9]{11}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 10.85,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'france',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'DE' : {
      name: 'Germany',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'DE89370400440532013000',
      bank_account_digits: '22 characters',
      bank_account_min: 22,
      bank_account_max: 22,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+49',
      calling_digits: '11 digits',
      calling_format: '30 901820',
      calling_min: 11,
      calling_max: 11,
      code: 'DE',
      company_tax: 'required',
      company_tax_label: 'Commercial registry number (Handelsregisternummer)',
      company_tax_format: 'HR_ 12345',
      company_tax_digits: '9 digit',
      company_tax_min: 8,
      company_tax_max: 9,
      company_tax_link: '',
      company_tax_pattern: '[H]{1}[R]{1}[A-Z]{1}[0-9]{5,6}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (USt-IdNr.)',
      company_vat_digits: 'DE then 9 digits',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'DE123456789',
      company_vat_link: '',
      company_vat_pattern: '[D]{1}[E]{1}[0-9]{9}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 12,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'State',
      slug: 'germany',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'GI' : {
      name: 'Gibraltar',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'GI75NWBK000000007099453',
      bank_account_digits: '23 characters',
      bank_account_min: 23,
      bank_account_max: 23,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+350',
      calling_digits: '12 digits',
      calling_format: '200 12345',
      calling_min: 12,
      calling_max: 12,
      code: 'GI',
      company_tax: 'required',
      company_tax_label: 'Tax Payer Identification (TIN) Number',
      company_tax_format: '123456',
      company_tax_digits: '6 digit',
      company_tax_min: 6,
      company_tax_max: 6,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{5,6}',
      currency: 'gip',
      currency_decimals: 2,
      currency_symbol: '£',
      minimum_wage: 8.90,
      post_code: 'required',
      post_code_label: 'Post code',
      post_code_digits: '7 character',
      post_code_format: 'GX11 1AA',
      post_code_min: 7,
      post_code_max: 8,
      post_code_prefix: '',
      region_state: 'Region or State',
      slug: 'gibraltar',
      tax_label: 'Corporate Tax',
      tax_rate: 15,
      town_city: 'Districts'
    },
    'GL' : {
      name: 'Global',
      region_state: 'Countries',
      slug: 'global',
      town_city: 'Cities'
    },
    'GR' : {
      name: 'Greece',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'GR1601101250000000012300695',
      bank_account_digits: '27 characters',
      bank_account_min: 27,
      bank_account_max: 27,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+30',
      calling_digits: '12-13 digits',
      calling_format: '21 0 123 4567',
      calling_min: 12,
      calling_max: 13,
      code: 'GR',
      company_tax: 'required',
      company_tax_label: 'Central Commercial Registry number (Γ.Ε.ΜΗ.)',
      company_tax_format: '123456789012',
      company_tax_digits: '12 digit',
      company_tax_min: 12,
      company_tax_max: 12,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{12}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (ΑΦΜ)',
      company_vat_digits: 'EL followed by 9 digits',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'EL123456789',
      company_vat_link: '',
      company_vat_pattern: '[E]{1}[L]{1}[0-9]{9}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 4.28,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'greece',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'HK' : {
      name: 'Hong Kong',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '123456-789',
      bank_account_digits: '6-9 character',
      bank_account_min: 6,
      bank_account_max: 9,
      bank_account_pattern: '[0-9]{6,9}',
      bank_routing: 'required',
      bank_routing_label: 'Routing number',
      bank_routing_format: '123-456',
      bank_routing_digits: '3 digit bank code & 3 digit branch code',
      bank_routing_min: 6,
      bank_routing_max: 7,
      bank_routing_pattern: '[0-9]{3}[-]{1}[0-9]{3}',
      calling: '+852',
      calling_digits: '12 digits',
      calling_format: '1234 5678',
      calling_min: 11,
      calling_max: 12,
      code: 'HK',
      company_tax: 'required',
      company_tax_label: 'Business registration number',
      company_tax_format: '12312312',
      company_tax_digits: '8 digit',
      company_tax_min: 8,
      company_tax_max: 8,
      company_tax_link: 'https://www.ird.gov.hk/eng/tax/bre.htm',
      company_tax_pattern: '[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'Company registration number (CRN)',
      company_vat_digits: '7 digit',
      company_vat_min: 7,
      company_vat_max: 7,
      company_vat_format: '1234567',
      company_vat_link: '',
      company_vat_pattern: '[0-9]{7}',
      currency: 'hkd',
      currency_decimals: 2,
      currency_symbol: 'HK$',
      individual_id: 'required',
      individual_id_label: 'Hong Kong Identity Card (HKID)',
      individual_id_digits: '1 or 2 letters, 6 numbers, check digit 0-9 or A',
      individual_id_min: 8,
      individual_id_max: 9,
      individual_id_format: 'HK 123456 A',
      individual_id_pattern: '[A-Z]{1,2}[0-9]{6}[0-9A]{1}',
      minimum_wage: 37.50,
      post_code: 'not-required',
      post_code_label: 'Post code',
      post_code_digits: 'not required',
      post_code_format: '00000',
      post_code_min: '',
      post_code_max: '',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'hong-kong',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'HU' : {
      name: 'Hungary',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'HU42117730161111101800000000',
      bank_account_digits: '28 characters',
      bank_account_min: 28,
      bank_account_max: 28,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+36',
      calling_digits: '11-12 digits',
      calling_format: '61 2345 678',
      calling_min: 11,
      calling_max: 12,
      code: 'HU',
      company_tax: 'required',
      company_tax_label: 'Company registration number (Cégjegyzékszám)',
      company_tax_format: '01-01-123456',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT ID (Adószám)',
      company_vat_digits: 'HU followed by 11 digits',
      company_vat_min: 13,
      company_vat_max: 13,
      company_vat_format: 'HU12345678912',
      company_vat_link: '',
      company_vat_pattern: '[H]{1}[U]{1}[0-9]{11}',
      currency: 'huf',
      currency_decimals: 2,
      currency_symbol: 'ft',
      minimum_wage: 996,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'County',
      slug: 'hungary',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'IE' : {
      name: 'Ireland',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'IE29AIBK93115212345678',
      bank_account_digits: '22 characters',
      bank_account_min: 22,
      bank_account_max: 22,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+353',
      calling_digits: '12 digits',
      calling_format: '123 456 789',
      calling_min: 12,
      calling_max: 13,
      code: 'IE',
      company_tax: 'required',
      company_tax_label: 'Company number',
      company_tax_digits: '6 digit',
      company_tax_min: 6,
      company_tax_max: 6,
      company_tax_format: '123456',
      company_tax_link: 'https://www.cro.ie/Publications/Business-Names-Forms',
      company_tax_pattern: '[0-9]{6}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 10.50,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '7 character',
      post_code_format: 'ANN ANAN',
      post_code_min: 7,
      post_code_max: 8,
      post_code_prefix: '',
      region_state: 'County',
      slug: 'ireland',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'IT' : {
      name: 'Italy',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'IT60X0542811101000000123456',
      bank_account_digits: '27 characters',
      bank_account_min: 27,
      bank_account_max: 27,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+39',
      calling_digits: '12-13 digits',
      calling_format: '338 123 4567',
      calling_min: 12,
      calling_max: 13,
      code: 'IT',
      company_tax: 'required',
      company_tax_label: 'RI/REA number',
      company_tax_format: '123456789',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (P.IVA)',
      company_vat_digits: 'IT followed by 11 digits',
      company_vat_min: 13,
      company_vat_max: 13,
      company_vat_format: 'IT12345678901',
      company_vat_link: '',
      company_vat_pattern: '[I]{1}[T]{1}[0-9]{11}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'italy',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'JP' : {
      name: 'Japan',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '1234567',
      bank_account_digits: '7-8 character',
      bank_account_min: 7,
      bank_account_max: 8,
      bank_account_pattern: '[0-9]{7,8}',
      bank_routing: 'required',
      bank_routing_label: 'Routing number',
      bank_routing_format: '1234-567',
      bank_routing_digits: '4 digit bank code & 3 digit branch code',
      bank_routing_min: 7,
      bank_routing_max: 8,
      bank_routing_pattern: '[0-9]{7,8}',
      calling: '+81',
      calling_digits: '12 digit',
      calling_format: '3 3224 9999',
      calling_min: 12,
      calling_max: 12,
      code: 'JP',
      company_tax: 'required',
      company_tax_label: 'Corporate number (Corporate "My Number")',
      company_tax_format: '7123456789012',
      company_tax_digits: '13 digit',
      company_tax_min: 13,
      company_tax_max: 13,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{13}',
      currency: 'jpy',
      currency_decimals: 0,
      currency_symbol: '¥',
      individual_id: 'required',
      individual_id_label: 'Individual Number (個人番号, kojin bangō)',
      individual_id_digits: '12 digit',
      individual_id_min: 12,
      individual_id_max: 12,
      individual_id_format: '123456789012',
      individual_id_pattern: '[0-9]{12}',
      minimum_wage: 940,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '7 digit',
      post_code_format: 'NNN-NNNN',
      post_code_min: 7,
      post_code_max: 8,
      post_code_pattern: '[0-9]{3}[-][0-9]{4}',
      post_code_prefix: '',
      product_description: 'required',
      region_state: 'Prefecture',
      slug: 'japan',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'LV' : {
      name: 'Latvia',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'LV80BANK0000435195001',
      bank_account_digits: '21 characters',
      bank_account_min: 21,
      bank_account_max: 21,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+371',
      calling_digits: '12 digits',
      calling_format: '23 45 67 89',
      calling_min: 12,
      calling_max: 12,
      code: 'LV',
      company_tax: 'required',
      company_tax_label: 'Central Court Registry Number',
      company_tax_format: '12345678901',
      company_tax_digits: '11 digit',
      company_tax_min: 11,
      company_tax_max: 11,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{11}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (PVN)',
      company_vat_digits: 'LV followed by 11 digits',
      company_vat_min: 13,
      company_vat_max: 13,
      company_vat_format: 'LV12345678901',
      company_vat_link: '',
      company_vat_pattern: '[L]{1}[V]{1}[0-9]{11}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 2.93,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: 'LV',
      region_state: 'Region',
      slug: 'latvia',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'LT' : {
      name: 'Lithuania',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'LT121000011101001000',
      bank_account_digits: '20 characters',
      bank_account_min: 20,
      bank_account_max: 20,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+370',
      calling_digits: '12 digits',
      calling_format: '82 345 678',
      calling_min: 12,
      calling_max: 12,
      company_tax: 'required',
      company_tax_label: 'Central Commercial Registry Number / Certificate Number',
      company_tax_format: '1234567',
      company_tax_digits: '7 digit',
      company_tax_min: 7,
      company_tax_max: 7,
      company_tax_link: '',
      company_tax_pattern: '[0-9]{7}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (PVM kodas)',
      company_vat_digits: 'LT followed by 9 digits',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'LT123456789',
      company_vat_link: '',
      company_vat_pattern: '[L]{1}[T]{1}[0-9]{9}',
      code: 'LT',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 4.56,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: 'LT',
      region_state: 'Region',
      slug: 'lithuania',
      tax_label: 'GST',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'LU' : {
      name: 'Luxembourg',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'LU280019400644750000',
      bank_account_digits: '20 characters',
      bank_account_min: 20,
      bank_account_max: 20,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+352',
      calling_digits: '11 digits',
      calling_format: '479 3301',
      calling_min: 11,
      calling_max: 11,
      code: 'LU',
      company_tax: 'required',
      company_tax_label: 'Company/RCS number',
      company_tax_digits: '13 digit',
      company_tax_min: 13,
      company_tax_max: 13,
      company_tax_format: '9999999999999',
      company_tax_link: 'https://www.rcsl.lu/',
      company_tax_pattern: '[0-9]{13}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: 'LU + 8 digits',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: 'LU 12345678',
      company_vat_link: '',
      company_vat_pattern: '[L]{1}[U]{1}[0-9]{8}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 11.84,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Canton',
      slug: 'luxembourg',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'MY' : {
      name: 'Malaysia',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '1234567890',
      bank_account_digits: '5-17 digits, format varies by bank',
      bank_account_min: 5,
      bank_account_max: 17,
      bank_account_pattern: '[0-9]+',
      bank_routing: 'required',
      bank_routing_label: 'Bank routing number',
      bank_routing_format: 'ABCDEFGH',
      bank_routing_digits: '8 letter',
      bank_routing_min: 8,
      bank_routing_max: 8,
      bank_routing_pattern: '[A-Z]{8}',
      calling: '+60',
      calling_digits: '12 digits',
      calling_format: '12-345 6789',
      calling_min: 11,
      calling_max: 12,
      code: 'MY',
      company_tax: 'required',
      company_tax_label: 'Company Number (MyCoID)',
      company_tax_digits: '6 digit - 1 letter',
      company_tax_min: 7,
      company_tax_max: 8,
      company_tax_format: '123456-A',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{6}[-]{1}[A-Z]{1}',
      currency: 'myr',
      currency_decimals: 2,
      currency_symbol: 'RM',
      individual_id: 'required',
      individual_id_label: 'Individual NRIC (MyKad)',
      individual_id_digits: '6 digit - 2 digit - 4 digit',
      individual_id_min: 12,
      individual_id_max: 14,
      individual_id_format: '000101-12-3456',
      individual_id_pattern: '[0-9]{6}[-]{1}[0-9]{2}[-]{1}[0-9]{4}',
      minimum_wage: 7.21,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'State',
      slug: 'malaysia',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'MT' : {
      name: 'Malta',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'MT84MALT011000012345MTLCAST001S',
      bank_account_digits: '31 characters',
      bank_account_min: 31,
      bank_account_max: 31,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+356',
      calling_digits: '12 digits',
      calling_format: '1234 5678',
      calling_min: 12,
      calling_max: 12,
      code: 'MT',
      company_tax: 'required',
      company_tax_label: 'Company Registration Number',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_format: '0123456789',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: 'MT + 8 digits, space, then 1 digit',
      company_vat_min: 11,
      company_vat_max: 12,
      company_vat_format: 'MT12345678 8',
      company_vat_link: '',
      company_vat_pattern: '[M]{1}[T]{1}[0-9]{8} [0-9]{1}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 4.24,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '3 letter, space, 4 digit',
      post_code_format: 'AAA NNNN',
      post_code_min: 7,
      post_code_max: 8,
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'malta',
      tax_label: 'VAT',
      tax_rate: 15,
      town_city: 'Towns & Cities'
    },
    'NL' : {
      name: 'Netherlands',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'NL39RABO0300065264',
      bank_account_digits: '18 characters',
      bank_account_min: 18,
      bank_account_max: 18,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+31',
      calling_digits: '12 digits',
      calling_format: '123 456 789',
      calling_min: 12,
      calling_max: 12,
      code: 'NL',
      company_tax: 'required',
      company_tax_label: 'KVK number',
      company_tax_digits: '8 digit',
      company_tax_min: 8,
      company_tax_max: 8,
      company_tax_format: '12345678',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (Btw-nr.)',
      company_vat_digits: 'NL + 9 digits, B then 2 digits',
      company_vat_min: 14,
      company_vat_max: 14,
      company_vat_format: 'NL123456789B01',
      company_vat_link: '',
      company_vat_pattern: '[N]{1}[L]{1}[0-9]{9}[B]{1}[0-9]{2}',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 9.81,
      post_code: 'required',
      post_code_label: 'Postcode',
      post_code_digits: '4 digits followed by 2 letters',
      post_code_format: 'NNNN AA',
      post_code_min: 6,
      post_code_max: 6,
      post_code_prefix: '',
      post_code_pattern: '[0-9]{4}[A-Z]{2}',
      region_state: 'Province',
      slug: 'netherlands',
      tax_label: 'VAT',
      tax_rate: 15,
      town_city: 'Towns & Cities'
    },
    'NZ' : {
      name: 'New Zealand',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '3456789-000',
      bank_account_digits: '9-10 digits required',
      bank_account_min: 9,
      bank_account_max: 10,
      bank_account_pattern: '[0-9]{9,10}',
      bank_routing: 'required',
      bank_routing_label: 'Bank code',
      bank_routing_format: '01-2345',
      bank_routing_digits: '6 character',
      bank_routing_min: 6,
      bank_routing_max: 6,
      bank_routing_pattern: '[0-9]{6,6}',
      calling: '+64',
      calling_digits: '10 digits',
      calling_format: '21 234 567',
      calling_min: 10,
      calling_max: 11,
      code: 'NZ',
      currency: 'nzd',
      currency_decimals: 2,
      currency_symbol: 'NZ$',
      company_tax: 'required',
      company_tax_label: 'New Zealand Business Number (NZBN)',
      company_tax_digits: '13 digit',
      company_tax_min: 13,
      company_tax_max: 13,
      company_tax_format: '9412345678901',
      company_tax_link: 'https://www.nzbn.govt.nz/get-an-nzbn/get-your-nzbn',
      company_tax_pattern: '[0-9]{13}',
      company_vat: 'optional',
      company_vat_label: 'GST number',
      company_vat_digits: '8 or 9 digit',
      company_vat_min: 8,
      company_vat_max: 9,
      company_vat_format: '100100100',
      company_vat_link: 'https://www.ird.govt.nz/gst/registering-for-gst',
      company_vat_pattern: '[0-9]{8,9}',
      individual_tax: 'required',
      individual_tax_label: 'IRD number',
      individual_tax_digits: '8 or 9 digit',
      individual_tax_min: 8,
      individual_tax_max: 9,
      individual_tax_format: '100100100',
      individual_tax_link: 'https://www.ird.govt.nz/activities/apply-for-a-personal-ird-number',
      individual_tax_pattern: '[0-9]{8,9}',
      individual_vat: 'optional',
      individual_vat_label: 'GST number',
      individual_vat_digits: '8 or 9 digit',
      individual_vat_min: 8,
      individual_vat_max: 9,
      individual_vat_format: '100100100',
      individual_vat_link: 'https://www.ird.govt.nz/gst/registering-for-gst',
      individual_vat_pattern: '[0-9]{8,9}',
      minimum_wage: 21.20,
      post_code: 'required',
      post_code_label: 'Postcode',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'new-zealand',
      tax_label: 'GST',
      tax_rate: 15,
      town_city: 'Towns & Cities'
    },
    'NO' : {
      name: 'Norway',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'NO9386011117947',
      bank_account_digits: '15 characters',
      bank_account_min: 15,
      bank_account_max: 15,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+47',
      calling_digits: '11 digits',
      calling_format: '23 456 789',
      calling_min: 11,
      calling_max: 11,
      code: 'NO',
      company_tax: 'required',
      company_tax_label: 'Organization number (Orgnr)',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_format: '123456789',
      company_tax_link: 'https://www.altinn.no/no/Skjema-og-tjenester/Etater/Bronnoysundregistrene/Samordnet-registermelding---Hovedblankett/',
      company_tax_pattern: '[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: '12 digits ending in MVA',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: '123456789MVA',
      company_vat_link: '',
      company_vat_pattern: '[0-9]{9}[M]{1}[V]{1}[A]{1}',
      currency: 'nok',
      currency_decimals: 2,
      currency_symbol: 'kr',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'County',
      slug: 'norway',
      tax_label: 'VAT',
      tax_rate: 19,
      town_city: 'Towns & Cities'
    },
    'PE' : {
      name: 'Peru',
      bank_account: 'required',
      bank_account_label: 'CCI',
      bank_account_format: '99934500012345670024',
      bank_account_digits: '20 digits',
      bank_account_min: 20,
      bank_account_max: 20,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+51',
      code: 'PE',
      currency: 'pen',
      currency_decimals: 2,
      currency_symbol: 'S/.',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Province',
      slug: 'peru',
      tax_label: 'VAT',
      tax_rate: 10,
      town_city: 'Towns & Cities'
    },
    'PL' : {
      name: 'Poland',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'PL61109010140000071219812874',
      bank_account_digits: '28 characters',
      bank_account_min: 28,
      bank_account_max: 28,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+48',
      calling_digits: '12 digits',
      calling_format: '22 3456 789',
      calling_min: 12,
      calling_max: 12,
      code: 'PL',
      company_tax: 'required',
      company_tax_label: 'REGON number',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_format: '610123456',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (NIP)',
      company_vat_digits: '10 digit',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: '1234563218',
      company_vat_link: '',
      company_vat_pattern: '[0-9]{10}',
      currency: 'pln',
      currency_decimals: 2,
      currency_symbol: 'zł',
      minimum_wage: 19.70,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NN-NNN',
      post_code_min: 5,
      post_code_max: 6,
      post_code_pattern: '[0-9]{2}\-[0-9]{3}',
      post_code_prefix: '',
      region_state: 'Province',
      slug: 'poland',
      tax_label: 'VAT',
      tax_rate: 19,
      town_city: 'Towns & Cities'
    },
    'PT' : {
      name: 'Portugal',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'PT50123443211234567890172',
      bank_account_digits: '25 characters',
      bank_account_min: 25,
      bank_account_max: 25,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+351',
      calling_digits: '13 digits',
      calling_format: '123 456 789',
      calling_min: 12,
      calling_max: 13,
      company_tax: 'required',
      company_tax_label: 'VAT number',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_format: '123456789',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (NIF or NIPC)',
      company_vat_digits: '9 digits, beginning with 5',
      company_vat_min: 9,
      company_vat_max: 9,
      company_vat_format: '523456789',
      company_vat_link: '',
      company_vat_pattern: '[5]{1}[0-9]{8}',
      code: 'PT',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 5.14,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digits, a hyphen, then 3 digits',
      post_code_format: 'NNNN-NNN',
      post_code_min: 7,
      post_code_max: 8,
      post_code_pattern: '[0-9]{4}\-[0-9]{3}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'portugal',
      tax_label: 'VAT',
      tax_rate: 19,
      town_city: 'Towns & Cities'
    },
    'RO' : {
      name: 'Romania',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'RO49AAAA1B31007593840000',
      bank_account_digits: '24 characters',
      bank_account_min: 24,
      bank_account_max: 24,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+40',
      calling_digits: '11-12 digits',
      calling_format: '234 567 891',
      calling_min: 11,
      calling_max: 12,
      code: 'RO',
      currency: 'ron',
      currency_decimals: 2,
      currency_symbol: 'lei',
      company_tax: 'required',
      company_tax_label: 'Codul de identificare fiscală (CIF/CUI)',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_format: '1123581321',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (CIF)',
      company_vat_digits: '8 digits, preceeded with RO',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: 'RO89144233',
      company_vat_link: '',
      company_vat_pattern: '^[R]{1,1}[O]{1,1}[0-9]{8,8}$',
      minimum_wage: 15.24,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '6 digits',
      post_code_format: '123456',
      post_code_min: 6,
      post_code_max: 6,
      post_code_pattern: '[0-9]{6}',
      post_code_prefix: '',
      region_state: 'County',
      slug: 'romania',
      tax_label: 'VAT',
      tax_rate: 19,
      town_city: 'Towns & Cities'
    },
    'SG' : {
      name: 'Singapore',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '1234567890123456789',
      bank_account_digits: '6-19 characters',
      bank_account_min: 6,
      bank_account_max: 19,
      bank_account_pattern: '[0-9]{6,19}',
      bank_routing: 'required',
      bank_routing_label: 'Routing number',
      bank_routing_format: '1234-567',
      bank_routing_digits: '4 digit bank code & 3 digit branch code',
      bank_routing_min: 7,
      bank_routing_max: 8,
      bank_routing_pattern: '[0-9]{4}[-]{1}[0-9]{3}',
      calling: '+65',
      calling_digits: '8 digits',
      calling_format: '8765 4321',
      calling_min: 11,
      calling_max: 12,
      code: 'SG',
      company_structure: 'required',
      company_tax: 'required',
      company_tax_label: 'Tax Identification Number (TIN)',
      company_tax_digits: '9-10 digit',
      company_tax_min: 9,
      company_tax_max: 10,
      company_tax_format: '1234567890',
      company_tax_pattern: '[0-9]{9,10}',
      currency: 'sgd',
      currency_decimals: 2,
      currency_symbol: 'SG$',
      individual_id: 'required',
      individual_id_label: 'NRIC or FIN',
      individual_id_digits: '9 character',
      individual_id_min: 9,
      individual_id_max: 9,
      individual_id_format: 'S1234567A',
      individual_id_pattern: '[S]{1}[0-9]{7}[A]{1}',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '6 digit',
      post_code_format: 'NNNNNN',
      post_code_min: 6,
      post_code_max: 6,
      post_code_pattern: '[0-9]{6}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'singapore',
      tax_label: 'VAT',
      tax_rate: 7,
      town_city: 'Towns & Cities'
    },
    'SK' : {
      name: 'Slovakia',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'SK3112000000198742637541',
      bank_account_digits: '24 characters',
      bank_account_min: 24,
      bank_account_max: 24,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+421',
      calling_digits: '14 digits',
      calling_format: '1234 567 890',
      calling_min: 13,
      calling_max: 14,
      code: 'SK',
      company_tax: 'required',
      company_tax_label: 'Tax Identification Number (TIN)',
      company_tax_digits: '10 digits',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_format: '1234567890',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT Identification Number',
      company_vat_digits: 'VAT number, 10 digit TIN preceeded with SK',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: 'SK1234567890',
      company_vat_link: '',
      company_vat_pattern: '^[S]{1}[K]{1}[0-9]{10}$',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 3.58,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNN NN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'slovakia',
      tax_label: 'VAT',
      tax_rate: 20,
      town_city: 'Towns & Cities'
    },
    'SI' : {
      name: 'Slovenia',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'SI56263300012039086',
      bank_account_digits: '19 characters',
      bank_account_min: 19,
      bank_account_max: 19,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+386',
      calling_digits: '12 digits',
      calling_format: '1 234 56 78',
      calling_min: 12,
      calling_max: 12,
      code: 'SI',
      company_tax: 'required',
      company_tax_label: 'Tax Identification Number (TIN)',
      company_tax_digits: '8 digits',
      company_tax_min: 8,
      company_tax_max: 8,
      company_tax_format: '12345678',
      company_tax_pattern: '[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT Identification Number',
      company_vat_digits: 'VAT number, 8 digit TIN preceeded with SI',
      company_vat_min: 10,
      company_vat_max: 10,
      company_vat_format: 'SI12345678',
      company_vat_link: '',
      company_vat_pattern: '^[S]{1}[I]{1}[0-9]{8}$',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 5.88,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'slovenia',
      tax_label: 'VAT',
      tax_rate: 22,
      town_city: 'Towns & Cities'
    },
    'ES' : {
      name: 'Spain',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'ES9121000418450200051332',
      bank_account_digits: '24 characters',
      bank_account_min: 24,
      bank_account_max: 24,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+34',
      calling_digits: '12 digits',
      calling_format: '876 543 210',
      calling_min: 12,
      calling_max: 12,
      company_tax: 'required',
      company_tax_label: 'CIF (Certificado de Identificación Fiscal)',
      company_tax_digits: 'tax ID number, a letter followed by 8 digits',
      company_tax_min: 8,
      company_tax_max: 9,
      company_tax_format: 'B12345678',
      company_tax_link: 'http://www.rmc.es/Deno_solicitud.aspx',
      company_tax_pattern: '[A-Z]{1}[0-9]{8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number (NIF)',
      company_vat_digits: 'vat number, ES + 9 digits (first and last can be letters)',
      company_vat_min: 10,
      company_vat_max: 11,
      company_vat_format: 'ESA12345678',
      company_vat_link: '',
      company_vat_pattern: '^[E]{1}[S]{1}[A-z0-9]{1}[0-9]{7}[A-z0-9]{1}$',
      code: 'ES',
      currency: 'eur',
      currency_decimals: 2,
      currency_symbol: '€',
      minimum_wage: 7.82,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'spain',
      tax_label: 'VAT',
      tax_rate: 21,
      town_city: 'Towns & Cities'
    },
    'SE' : {
      name: 'Sweden',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'SE3550000000054910000003',
      bank_account_digits: '24 characters',
      bank_account_min: 24,
      bank_account_max: 24,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+46',
      calling_digits: '11-13 digits',
      calling_format: '12 3456 7890',
      calling_min: 11,
      calling_max: 13,
      code: 'SE',
      company_tax: 'required',
      company_tax_label: 'Organisation number',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_format: '123456-7890',
      company_tax_link: 'https://www.bolagsverket.se/',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'VAT identification number',
      company_vat_digits: '10 digit organisation number, preceeded with SE and end with 01',
      company_vat_min: 14,
      company_vat_max: 14,
      company_vat_format: 'SE 123456-7890 01',
      company_vat_link: '',
      company_vat_pattern: '[S]{1}[E]{1}[0-9]{10}[0]{1}[1]{1}',
      currency: 'sek',
      currency_decimals: 2,
      currency_symbol: 'kr',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '5 digit',
      post_code_format: 'NNN NN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'Province',
      slug: 'sweden',
      tax_label: 'VAT',
      tax_rate: 25,
      town_city: 'Towns & Cities'
    },
    'CH' : {
      name: 'Switzerland',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'CH9300762011623852957',
      bank_account_digits: '21 characters',
      bank_account_min: 21,
      bank_account_max: 21,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+41',
      calling_digits: '12 digits',
      calling_format: '432 109 876',
      calling_min: 12,
      calling_max: 12,
      code: 'CH',
      company_tax: 'required',
      company_tax_label: 'Business Identification Number (UID)',
      company_tax_digits: 'CHE and 9 digits',
      company_tax_min: 12,
      company_tax_max: 12,
      company_tax_format: 'CHE 123 456 789',
      company_tax_link: '',
      company_tax_pattern: '[C]{1}[H]{1}[E]{1}[0-9]{9}',
      company_vat: 'optional',
      company_vat_label: 'VAT Number',
      company_vat_digits: 'CHE and 9 digits',
      company_vat_min: 12,
      company_vat_max: 12,
      company_vat_format: 'CHE 123 456 789',
      company_vat_link: '',
      company_vat_pattern: '[C]{1}[H]{1}[E]{1}[0-9]{9}',
      currency: 'chf',
      currency_decimals: 2,
      currency_symbol: 'CHF',
      minimum_wage: 0,
      post_code: 'required',
      post_code_label: 'Postal code',
      post_code_digits: '4 digit',
      post_code_format: 'NNNN',
      post_code_min: 4,
      post_code_max: 4,
      post_code_pattern: '[0-9]{4}',
      post_code_prefix: '',
      region_state: 'Region',
      slug: 'switzerland',
      tax_label: 'VAT',
      tax_rate: 7.7,
      town_city: 'Towns & Cities'
    },
    'AE' : {
      name: 'United Arab Emirates',
      bank_account: 'required',
      bank_account_label: 'IBAN',
      bank_account_format: 'AE070331234567890123456',
      bank_account_digits: '21 characters',
      bank_account_min: 23,
      bank_account_max: 23,
      bank_account_pattern: '[A-z0-9]+',
      calling: '+971',
      calling_digits: '12 digits',
      calling_format: '4 321 0987',
      calling_min: 12,
      calling_max: 12,
      code: 'AE',
      company_structure: 'required',
      company_tax: 'required',
      company_tax_label: 'Company Registration Number (CR)',
      company_tax_digits: '10 digit',
      company_tax_min: 10,
      company_tax_max: 10,
      company_tax_format: '123 456 7890',
      company_tax_link: '',
      company_tax_pattern: '[0-9]{10}',
      company_vat: 'optional',
      company_vat_label: 'Tax Registration Number (TRN)',
      company_vat_digits: '15 digits',
      company_vat_min: 15,
      company_vat_max: 15,
      company_vat_format: '123 456 789 012 345',
      company_vat_link: '',
      company_vat_pattern: '[0-9]{15}',
      individual_id: 'required',
      individual_id_label: 'Emirates ID',
      individual_id_digits: '15 digit',
      individual_id_min: 15,
      individual_id_max: 15,
      individual_id_format: '123456789012345',
      individual_id_pattern: '[0-9]{15}',
      currency: 'aed',
      currency_decimals: 2,
      currency_symbol: 'د.إ',
      minimum_wage: 0,
      post_code: 'not-required',
      post_code_label: 'Post code',
      post_code_digits: 'not required',
      post_code_format: '00000',
      post_code_min: '',
      post_code_max: '',
      post_code_prefix: '',
      product_description: 'required',
      region_state: 'Region',
      slug: 'uae',
      tax_label: 'VAT',
      tax_rate: 5,
      town_city: 'Towns & Cities'
    },
    'GB' : {
      name: 'United Kingdom',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '01234567',
      bank_account_digits: '8 digits required',
      bank_account_min: 8,
      bank_account_max: 8,
      bank_account_pattern: '[0-9]+',
      bank_routing: 'required',
      bank_routing_label: 'Sort code',
      bank_routing_format: '12-34-56',
      bank_routing_digits: '6 digits',
      bank_routing_min: 6,
      bank_routing_max: 6,
      bank_routing_pattern: '[0-9]+',
      calling: '+44',
      calling_digits: '10 digits',
      calling_format: '1234 456789',
      calling_min: 12,
      calling_max: 13,
      code: 'GB',
      currency: 'gbp',
      currency_decimals: 2,
      currency_symbol: '£',
      company_tax: 'required',
      company_tax_label: 'Companies House Registration Number (CRN)',
      company_tax_digits: '7 or 8-digit Company Number',
      company_tax_min: 7,
      company_tax_max: 8,
      company_tax_format: '12345678',
      company_tax_link: 'https://ewf.companieshouse.gov.uk/runpage?page=webfilingRegister',
      company_tax_pattern: '[0-9]{7,8}',
      company_vat: 'optional',
      company_vat_label: 'VAT number',
      company_vat_digits: '9 digits, preceeded with GB',
      company_vat_min: 11,
      company_vat_max: 11,
      company_vat_format: 'GB123456789',
      company_vat_link: '',
      company_vat_pattern: '^[G]{1,1}[B]{1,1}[0-9]{9,9}$',
      minimum_wage: 9.50,
      post_code: 'required',
      post_code_label: 'Postcode',
      post_code_digits: '7 character',
      post_code_format: 'AANN NAA',
      post_code_min: 7,
      post_code_max: 8,
      post_code_pattern: '[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}',
      post_code_prefix: '',
      region_state: 'County',
      slug: 'uk',
      tax_label: 'VAT',
      tax_rate: 20,
      town_city: 'Towns & Cities'
    },
    'US' : {
      name: 'United States',
      bank_account: 'required',
      bank_account_label: 'Account number',
      bank_account_format: '3456789YZZ',
      bank_account_digits: 'Format varies by bank',
      bank_account_min: 10,
      bank_account_max: 12,
      bank_account_pattern: '[0-9]+',
      bank_routing: 'required',
      bank_routing_label: 'Routing number',
      bank_routing_format: '111000000',
      bank_routing_digits: '9 characters',
      bank_routing_min: 9,
      bank_routing_max: 9,
      bank_routing_pattern: '[0-9]+',
      calling: '+1',
      calling_digits: '10 digits',
      calling_format: '(555) 555-1234',
      calling_min: 12,
      calling_max: 12,
      code: 'US',
      currency: 'usd',
      currency_decimals: 2,
      currency_symbol: 'US$',
      company_tax: 'required',
      company_tax_label: 'Employer Identification Number (EIN)',
      company_tax_digits: '9 digit',
      company_tax_min: 9,
      company_tax_max: 9,
      company_tax_format: '12-3456789',
      company_tax_pattern: '[0-9]{9}',
      individual_tax: 'required',
      individual_tax_label: 'Taxpayer Identification Number (TIN)',
      individual_tax_digits: '9 digit',
      individual_tax_min: 9,
      individual_tax_max: 9,
      individual_tax_format: '12-3456789',
      individual_tax_pattern: '[0-9]{9}',
      individual_id: 'required',
      individual_id_label: 'Social Security Number (SSN)',
      individual_id_digits: '9 digit',
      individual_id_min: 9,
      individual_id_max: 9,
      individual_id_format: '123456789',
      individual_id_pattern: '[0-9]{9}',
      minimum_wage: 7.25,
      post_code: 'required',
      post_code_label: 'ZIP',
      post_code_digits: '5 digit',
      post_code_format: 'NNNNN',
      post_code_min: 5,
      post_code_max: 5,
      post_code_pattern: '[0-9]{5}',
      post_code_prefix: '',
      region_state: 'State',
      slug: 'us',
      tax_label: 'VAT',
      tax_rate: 0,
      town_city: 'Cities'
    }
  },
  regions: {
    'GL': ['New Zealand','Australia','Canada','UK','USA','Ireland','UAE','Singapore','Hong Kong','Japan','Germany','France','Italy','Spain','Switzerland','Malaysia','Sweden','Portugal','Norway','Austria','Netherlands','Belgium','Denmark','Finland','Czech Republic','Peru','Poland','Malta','Luxembourg','Cyprus','Greece','Slovakia','Slovenia','Hungary','Bulgaria','Latvia','Lithuania','Estonia','Romania'],
    'AU': ['New South Wales','Queensland','South Australia','Tasmania','Victoria','Western Australia','Australian Capital Territory','Northern Territories'],
    'AT': ['Burgenland','Carinthia','Lower Austria','Upper Austria','Salzburg','Styria','Tyrol','Vorarlberg','Vienna'],
    'BE': ['Antwerp','East Flanders','Flemish Brabant','Limburg','West Flanders','Hainaut','Liège','Luxembourg','Namur','Walloon Brabant','Brussels Capital Region'],
    'BG': ['Blagoevgrad','Burgas','Dobrich','Gabrovo','Grad Sofiya','Khaskovo','Kurdzhali','Kyustendil','Lovech','Montana','Pazardzhik','Pernik','Pleven','Plovdiv','Razgrad','Ruse','Shumen','Silistra','Sliven','Smolyan','Sofiya','Stara Zagora','Turgovishte','Varna','Veliko Turnovo','Vidin','Vratsa','Yambol'],
    'CA': ['Alberta','British Columbia','Manitoba','New Brunswick','Newfoundland and Labrador','Nova Scotia','Ontario','Prince Edward Island','Quebec','Saskatchewan','Northwest Territories','Nunavut','Yukon'],
    'CY': ['Famagusta','Kyrenia','Larnaca','Nicosia','Limassol','Paphos'],
    'CZ': ['South Bohemia','South Moravia','Karlovy Vary','Hradec Králové','Liberec','Moravia-Silesia','Olomouc','Pardubice','Plzeň','Prague','Central Bohemia','Ústí nad Labem','Vysočina','Zlín'],
    'DK': ['Capital Region of Denmark','Central Denmark Region','North Denmark Region','Region Zealand','Region of Southern Denmark'],
    'EE': ['Harju','Hiiu','Ida-Viru','Jõgeva','Järva','Lääne','Lääne-Viru','Põlva','Pärnu','Rapla','Saare','Tartu','Valga','Viljandi','Võru'],
    'FI': ['Åland','South Karelia','Southern Ostrobothnia','Southern Savonia','Kainuu','Tavastia Proper','Central Ostrobothnia','Central Finland','Kymenlaakso','Lapland','Pirkanmaa','Ostrobothnia','North Karelia','Northern Ostrobothnia','Northern Savonia','Päijänne Tavastia','Satakunta','Uusimaa','Southwest Finland'],
    'FR': ['Auvergne-Rhône-Alpes','Bourgogne-Franche-Comté','Bretagne','Centre-Val de Loire','Corse','Grand-Est','Guadeloupe','Hauts-de-France','Île-de-France','Mayotte','Normandie','Nouvelle-Aquitaine','Occitanie','Pays-de-la-Loire','Provence-Alpes-Côte-d’Azur','La Réunion'],
    'DE': ['Baden-Württemberg','Bavaria','Berlin','Brandenburg','Bremen','Hamburg','Hesse','Mecklenburg-Western Pomerania','Lower Saxony','North Rhine-Westphalia','Rhineland-Palatinate','Saarland','Saxony','Saxony-Anhalt','Schleswig-Holstein','Thuringia'],
    'GI': ['Gibraltar'],
    'GR': ['Eastern Macedonia and Thrace','Attica','Western Greece','Western Macedonia','Ionian Islands','Epirus','Central Macedonia','Crete','Southern Aegean','Peloponnese','Central Greece','Thessaly','Northern Aegean'],
    'HK': ['Hong Kong Island','Kowloon','New Territories'],
    'HU': ['Budapest','Bács-Kiskun','Baranya','Békés','Borsod-Abaúj-Zemplén','Csongrád','Fejér','Győr-Moson-Sopron','Hajdú-Bihar','Heves','Jász-Nagykun-Szolnok','Komárom-Esztergom','Nógrád','Pest','Somogy','Szabolcs-Szatmár-Bereg','Tolna','Vas','Veszprém','Zala','Békéscsaba','Debrecen','Dunaújváros','Eger','Érd','Győr','Hódmezővásárhely','Kaposvár','Kecskemét','Miskolc','Nagykanizsa','Nyíregyháza','Pécs','Salgótarján','Sopron','Szeged','Székesfehérvár','Szekszárd','Szolnok','Szombathely','Tatabánya','Veszprém','Zalaegerszeg'],
    'IE': ['Carlow','Cavan','Clare','Cork','Donegal','Dublin','Galway','Kerry','Kildare','Kilkenny','Laois','Leitrim','Limerick','Longford','Louth','Mayo','Meath','Monaghan','Offaly','Roscommon','Sligo','Tipperary','Waterford','Westmeath','Wexford','Wicklow'],
    'IT': ['Abruzzo','Basilicata','Calabria','Campania','Emilia-Romagna','Lazio','Liguria','Lombardy','Marche','Molise','Piedmont','Apulia','Tuscany','Umbria','Veneto'],
    'JP': ['Aiti','Akita','Aomori','Ehime','Gihu','Gunma','Hirosima','Hokkaidô','Hukui','Hukuoka','Hukusima','Hyôgo','Ibaraki','Isikawa','Iwate','Kagawa','Kagosima','Kanagawa','Kôti','Kumamoto','Kyôto','Mie','Miyagi','Miyazaki','Nagano','Nagasaki','Nara','Niigata','Ôita','Okayama','Okinawa','Ôsaka','Saga','Saitama','Siga','Simane','Sizuoka','Tiba','Totigi','Tokusima','Tôkyô','Tottori','Toyama','Wakayama','Yamagata','Yamaguti','Yamanasi'],
    'KANA': ['ほっかいどう','あおもりけん','あきたけん','いわてけん','やまがたけん','みやぎけん','にいがたけん','ふくしまけん','ぐんまけん','とちぎけん','いばらきけん','さいたまけん','ときょうと','ちばけん','かながわけん','やまなしけん','ながのけん','しずおかけん','とやまけん','いしかわけん','ふくいけん','ぎふけん','あいちけん','しがけん','みえけん','きようとふ','おおさかふ','ならけん','わかやまけん','ひょうごけん','とっとりけん','しまねけん','おかやまけん','ひろしまけん','やまぐちけん','かがわけん','とくしまけん','えひめけん','こうちけん','ふくおかけん','さがけん','ながさきけん','おおいたけん','くまもとけん','みやざきけん','かごしまけん','おきなわけん'],
    'KANJI': ['愛知県','秋田県','青森県','千葉県','愛媛県','福井県','福岡県','福島県','岐阜県','群馬県','広島県','北海道','兵庫県','茨城県','石川県','岩手県','香川県','鹿児島県','神奈川県','高知県','熊本県','京都府','三重県','宮城県','宮崎県','長野県','長崎県','奈良県','新潟県','大分県','岡山県','沖縄県','大阪府','佐賀県','埼玉県','滋賀県','島根県','静岡県','栃木県','徳島県','東京都','鳥取県','富山県','和歌山県','山形県','山口県','山梨県'],
    'LV': ['Riga','Kurzeme','Zemgale','Latgale','Vidzeme'],
    'LT': ['Alytus County','Kaunas County','Klaipėda County','Marijampolė County','Panevėžys County','Šiauliai County','Tauragė County','Telšiai County','Utena County','Vilnius County'],
    'LU': ['Capellen','Clervaux','Diekirch','Echternach','Esch-sur-Alzette','Grevenmacher','Luxembourg','Mersch','Redange','Remich','Vianden','Wiltz'],
    'MT': ['Central Region','Gozo Region','Northern Region','South Eastern Region','Southern Region'],
    'MY': ['Wilayah Persekutuan Kuala Lumpur','Wilayah Persekutuan Labuan','Wilayah Persekutuan Putrajaya','Johor','Kedah','Kelantan','Melaka','Negeri Sembilan','Pahang','Perak','Perlis','Pulau Pinang','Sabah','Sarawak','Selangor','Terengganu'],
    'NL': ['Drenthe','Flevoland','Friesland','Gelderland','Groningen','Limburg','North Brabant','North Holland','Overijssel','Utrecht','Zeeland','South Holland'],
    'NO': ['Akershus','Aust-Agder','Buskerud','Finnmark / Finnmárku (se)','Hedmark','Hordaland','Møre og Romsdal','Nordland','Oppland','Oslo','Rogaland','Sogn og Fjordane','Telemark','Troms / Romsa (se)','Trøndelag','Vest-Agder','Vestfold','Østfold','Jan Mayen','Svalbard'],
    'NZ': ['Northland','Auckland','Waikato','Bay of Plenty','Taranaki','Manawatu-Wanganui','Gisborne','Hawkes Bay','Wellington','Nelson','Tasman','Marlborough','West Coast','Chatham Islands Territory','Canterbury','Otago','Southland'],
    'PE': ['Municipalidad Metropolitana de Lima','Amazonas','Ancash','Apurímac','Arequipa','Ayacucho','Cajamarca','Cusco','El Callao','Huancavelica','Huánuco','Ica','Junín','La Libertad','Lambayeque','Lima','Loreto','Madre de Dios','Moquegua','Pasco','Piura','Puno','San Martín','Tacna','Tumbes','Ucayali'],
    'PL': ['Lower Silesia','Kuyavia-Pomerania','Lublin','Lubusz','Łódź','Lesser Poland','Mazovia','Opole (Upper Silesia)','Subcarpathia','Podlaskie','Pomerania','Silesia','Holy Cross','Warmia-Masuria','Greater Poland','West Pomerania'],
    'PT': ['Aveiro','Beja','Braga','Bragança','Castelo Branco','Coimbra','Évora','Faro','Guarda','Leiria','Lisboa','Portalegre','Porto','Santarém','Setúbal','Viana do Castelo','Vila Real','Viseu','Região Autónoma dos Açores','Região Autónoma da Madeira'],
    'RO': ['Alba','Arad','Argeș','Bacău','Bihor','Bistrița-Năsăud','Botoșani','Brașov','Brăila','Buzău','Caraș-Severin','Călărași','Cluj','Constanța','Covasna','Dâmbovița','Dolj','Galați','Giurgiu','Gorj','Harghita','Hunedoara','Ialomița','Iași','Ilfov','Maramureș','Mehedinți','Mureș','Neamț','Olt','Prahova','Satu Mare','Sălaj','Sibiu','Suceava','Teleorman','Timiș','Tulcea','Vaslui','Vâlcea','Vrancea','București'],
    'SG': ['Central Singapore','North East','North West','South East','South West'],
    'SK': ['Banska Bystrica','Bratislava','Košice','Nitra','Prešov','Trenčin','Trnava','Žilina'],
    'SI': ['Upper Carniola (Gorenjska) (U.C.)','Styria (Štajerska) (S)','Prekmurje (P)','Carinthia (Koroška) (C)','Inner Carniola (Notranjska) (I.C.)','Lower Carniola (Dolenjska) (L.C.)','Gorizia (Goriška) (G)','Slovenian Istria (Slovenska Istra) (L)'],
    'ES': ['Andalusia','Aragon','Principality of Asturias','Canary Islands','Cantabria','Castile and León','Castile-La Mancha','Catalonia','Ceuta','Extremadura','Galicia','Balearic Islands','La Rioja','Community of Madrid','Melilla','Region of Murcia','Chartered Community of Navarre','Basque','Valencian Community'],
    'SE': ['Blekinge län','Dalarnas län','Gotlands län','Gävleborgs län','Hallands län','Jämtlands län','Jönköpings län','Kalmar län','Kronobergs län','Norrbottens län','Skåne län','Stockholms län','Södermanlands län','Uppsala län','Värmlands län','Västerbottens län','Västernorrlands län','Västmanlands län','Västra Götalands län','Örebro län','Östergötlands län'],
    'CH': ['Lake Geneva region','Espace Mittelland','Northwestern Switzerland','Zurich','Eastern Switzerland','Central Switzerland','Ticino'],
    'AE': ['Abu Dhabi','Ajman','Fujairah','Sharjah','Dubai','Ras Al Khaimah','Umm Al Quwain'],
    'GB': ['Avon','Bedfordshire','Berkshire','City of Brighton and Hove','City of Bristol','Buckinghamshire','Cambridgeshire','Cheshire','Cleveland','Cornwall','Cumberland','Cumbria','Derbyshire','Devon','Dorset','Durham','East Suffolk','East Sussex','Essex','Gloucestershire','Greater London','Greater Manchester','Hampshire','Hereford and Worcester','Herefordshire','Hertfordshire','Humberside','Huntingdon and Peterborough','Huntingdonshire','Isle of Ely','Isle of Wight','Kent','Lancashire','Leicestershire','Lincolnshire','London','City of London','Merseyside','Middlesex','Norfolk','Northamptonshire','Northumberland','North Humberside','North Yorkshire','Nottinghamshire','Oxfordshire','Soke of Peterborough','Rutland','Shropshire','Somerset','South Humberside','South Yorkshire','Staffordshire','Suffolk','Surrey','Sussex','Tyne and Wear','Warwickshire','West Midlands','Westmorland','West Suffolk','West Sussex','West Yorkshire','Wiltshire','Worcestershire','Yorkshire','Antrim','Armagh','City of Belfast','Down','Fermanagh','Londonderry','City of Derry','Tyrone','City of Aberdeen','Aberdeenshire','Angus (Forfarshire)','Argyll','Ayrshire','Banffshire','Berwickshire','Bute','Caithness','Clackmannanshire','Cromartyshire','Dumfriesshire','Dunbartonshire (Dumbarton)','City of Dundee','East Lothian (Haddingtonshire)','City of Edinburgh','Fife','City of Glasgow','Inverness-shire','Kincardineshire','Kinross-shire','Kirkcudbrightshire','Lanarkshire','Midlothian (County of Edinburgh)','Moray (Elginshire)','Nairnshire','Orkney','Peeblesshire','Perthshire','Renfrewshire','Ross and Cromarty','Ross-shire','Roxburghshire','Selkirkshire','Shetland (Zetland)','Stirlingshire','Sutherland','West Lothian (Linlithgowshire)','Wigtownshire','Anglesey','Brecknockshire','Caernarfonshire','Cardiganshire','Carmarthenshire','Clwyd','Denbighshire','Dyfed','Flintshire','Glamorgan','Gwent','Gwynedd','Merionethshire','Mid Glamorgan','Monmouthshire','Montgomeryshire','Pembrokeshire','Powys','Radnorshire','South Glamorgan','West Glamorgan','Wrexham'],
    'US': ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming','District of Columbia']
  },
  types: ['Permanent','Contract'],
  salary: ['30','40','50','60','70','80','90','100','120','150','200'],
  rates: ['20','30','40','50','60','70','80','90','100']
}
